import { render, staticRenderFns } from "./ModalWorkerAdd.vue?vue&type=template&id=01bd172b&scoped=true"
import script from "./ModalWorkerAdd.vue?vue&type=script&lang=js"
export * from "./ModalWorkerAdd.vue?vue&type=script&lang=js"
import style0 from "./ModalWorkerAdd.vue?vue&type=style&index=0&id=01bd172b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bd172b",
  null
  
)

export default component.exports